import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { UIModule as UIWebModule } from '@ups/xplat/web/features';
import { LayoutModule } from '@ups/xplat/ionic/layout';
import { HeaderComponent } from './components';

@NgModule({
  imports: [UIWebModule, IonicModule, LayoutModule],
  declarations: [HeaderComponent],
  exports: [
    UIWebModule,
    IonicModule,
    LayoutModule,
    HeaderComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UIModule {}
